import { useCallback, useEffect, useState } from "react";
import { RefreshCw, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { useAuth } from "@/context/AuthContext";
import { api, errText } from "@/lib/api";
import { ROLE_NAMES, formatDate, channelsFor, channelName } from "@/lib/constants";
import { NativeSelect } from "@/components/NativeSelect";

export default function AdminChat() {
  const { user } = useAuth();
  const [msgs, setMsgs] = useState([]);
  const [q, setQ] = useState("");
  const [channel, setChannel] = useState("");
  const load = useCallback(() => { api.get("/admin/chat", { params: channel ? { channel } : {} }).then((r) => setMsgs(r.data)).catch(() => {}); }, [channel]);
  useEffect(() => { load(); }, [load]);

  const remove = async (m) => {
    try { await api.delete(`/admin/chat/${m.id}`); toast.success("Сообщение удалено"); load(); }
    catch (e) { toast.error(errText(e)); }
  };
  const ql = q.toLowerCase();
  const shown = msgs.filter((m) => m.text.toLowerCase().includes(ql) || m.author.toLowerCase().includes(ql));

  return (
    <div>
      <div className="flex flex-wrap gap-2">
        <NativeSelect value={channel} onChange={(e) => setChannel(e.target.value)} className="max-w-[220px]" data-testid="admin-chat-channel-select">
          <option value="">Все чаты</option>
          {channelsFor(user).map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
        </NativeSelect>
        <Input placeholder="Поиск по тексту или автору" value={q} onChange={(e) => setQ(e.target.value)} className="max-w-xs bg-white" data-testid="admin-chat-search-input" />
        <button onClick={load} className="h-10 px-4 rounded-full border border-[#d1e7dd] bg-white text-sm font-semibold text-[#1f5f42] inline-flex items-center gap-1.5" data-testid="admin-chat-refresh-button"><RefreshCw className="h-4 w-4" />Обновить</button>
      </div>
      <div className="mt-5 rounded-2xl bg-white border border-[#d1e7dd] divide-y divide-[#eef6f1]" data-testid="admin-chat-list">
        {shown.length === 0 && <p className="p-8 text-center text-sm text-[#6b8a7b]">Сообщений нет</p>}
        {shown.map((m) => (
          <div key={m.id} className="p-4 flex items-start gap-3" data-testid={`admin-chat-message-${m.id}`}>
            <div className="flex-1 min-w-0">
              <div className="text-xs text-[#6b8a7b]"><span className="font-bold text-[#1f5f42]">{m.author}</span> · {ROLE_NAMES[m.role]}{m.grade ? ` · ${m.grade} кл.` : ""} · {formatDate(m.created_at)} · <span className="font-semibold text-[#2e7d56]">{channelName(m.channel)}</span></div>
              <div className="text-sm text-[#0b2e20] mt-1 whitespace-pre-wrap break-words">{m.text}</div>
            </div>
            <button onClick={() => remove(m)} className="h-8 w-8 grid place-items-center rounded-full text-red-600 hover:bg-red-50 shrink-0" data-testid={`admin-delete-chat-${m.id}`}><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
